export const de = {
  clipboard: {
    successCopied: "In die Zwischenablage kopiert",
  },
  notification: {
    title: "Benachrichtigungseinstellungen",
    emailNotifications: "E-Mail-Benachrichtigungen",
    marketingEmails: "Marketing-E-Mails"
  },
  safety: {
    title: "KYC-Verifizierung",
    subtitle: "Schließen Sie die Verifizierung ab, um alle Funktionen der Plattform zu nutzen.",
    bannerTitle: "Verifizierung über Reown",
    bannerText1: "Ihr Konto verwendet Reown-Authentifizierung.",
    bannerText2: "Um Ihr Verifizierungslevel zu erhöhen, gehen Sie zum Bereich \"Verifizierung\".",
    standardLevel: "Standardstufe",
    standardDesc: "Bestätigung von E-Mail und Telefonnummer.",
    enhancedLevel: "Erweiterte Stufe",
    enhancedDesc: "Übermittlung der Ausweisdaten.",
    professionalLevel: "Professionelle Stufe",
    professionalDesc: "Nachweis der Wohnadresse.",
    completed: "Abgeschlossen",
    inProgress: "In Bearbeitung",
    start: "Starten"
  },
  referral: {
    title: "Empfehlungsprogramm",
    description: "Laden Sie Freunde ein und verdienen Sie Prämien!",
    subtitle: "Ihr Empfehlungslink",
    yourReferrals: "Ihre Empfehlungen",
    statsElements: ["Gesamt", "Aktiv", "Gesamtinvestitionen", "Ihre Einnahmen"],
    yourLevel: {
      topTitle: "Ihr Level",
      toNextLevel: "Nächstes Level:",
      activeReferralsOr: "aktive Empfehlungen ODER",
      toLvl: "bis"
    },
    referrer: {
      title: "Haben Sie einen Empfehlungscode? Geben Sie ihn hier ein",
      enterCode: "Code eingeben",
      check: "Prüfen"
    },
    confirm: "Bestätigen",
    changeRefCode: "Empfehlungscode ändern",
    newCode: "neuer Code",
    enterNewCode: "Geben Sie Ihren neuen Code ein",
    minMaxChars: "Mindestens 6 Zeichen, maximal 8"
  },
  referralNew: {
    code: {
      title: "Hast du einen Empfehlungscode?",
      description: "Gib ihn unten ein, um dich mit\ndeinem Einladenden zu verbinden.",
      input: "Empfehlungscode",
      button: "Überprüfen",
      title_CodeVerified: "Code verifiziert",
      description_CodeVerified: "Du kannst jetzt andere einladen und Belohnungen verdienen.",
      youInviter: "dein Einladender"
    },
    details: {
      title: "Deine Empfehlungsdetails",
      description: "Lade Freunde zu Zenex ein und verdiene Boni.",
      sendThis: "Sende diesen Link an deinen Freund",
      orShare: "Oder teile deinen manuellen Code",
      members: "Mitglieder",
      paidOut: "im Jahr 2025 ausgezahlt",
      alreadyEarning: "verdienen bereits mit uns"
    },
    program: {
      button: "Mehr erfahren",
      cards: {
        title: "Monatliche Stufen",
        subtitle: "Partnerprogramm",
        description: "Verdiene an den Kartentransaktionen deiner Empfehlungen",
        how: "Wie es funktioniert",
        elements: [
          "Gesamtes Aufladevolumen aller Empfehlungen pro Kalendermonat",
          "Status wird am 1. jedes Monats neu berechnet",
          "Provision wird gemäß deiner aktuellen Stufe bezahlt"
        ]
      },
      invest: {
        title: "Kumulatives System",
        subtitle: "Empfehlungsprogramm",
        description: "Verdiene an den Investitionen deiner Freunde",
        how: "Wie man verdient",
        elements: [
          "Lade einen Freund ein, sich bei Zenex Invest anzuschließen",
          "Er beginnt, in Zenex Pools zu investieren",
          "Du erhältst Belohnungen aus seinen Erträgen"
        ]
      }
    }
  },
  innerReferral: {
    title: "Empfehlungsprogramm \n Zenex Invest",
    statistic: {
      pattern: " in diesem Monat",
      status: {
        title: "Aktueller Status",
        subtitle: "Ihre Boni: ",
        description: "{depositBonus} aus der Einzahlung und {incomeBonus} aus dem Gewinn",
        labelLeft: "Bis {level}",
        labelCenter: "{count, plural, one {# Empfehlung} other {# Empfehlungen}} oder",
        labelRight: ""
      },
      referrals: {
        title: "Aktive Empfehlungen",
        description: "+{count} neu",
      },
      deposit: {
        title: "Gesamteinzahlungsbetrag",
        description: "+{count}$"
      },
      income: {
        title: "Mein Einkommen",
        description: "~{count}$",
        pattern: "/pro Monat",
      },
    },
    link: {
      title: "Erhöhen Sie Ihren Status und verdienen Sie mehr",
      sendThis: "Senden Sie diesen Link an einen Freund",
      orShare: "Oder geben Sie den Code zur manuellen Eingabe weiter",
    },
    tabs: {
      levels: "Levelsystem",
      history: "Auszahlungsverlauf",
      referrals: "Empfehlungsliste",
    },
    faq: {
      kicker: "FAQ",
      title: "Wie das Empfehlungssystem funktioniert",
      questions: [
        "Wo werden meine Empfehlungsbelohnungen gutgeschrieben und wie kann ich sie abheben?",
        "Ist der Empfehlungslink für jedes Produkt unterschiedlich oder gibt es einen einzigen Link?",
        "Ich habe einen Freund eingeladen, der in den RevShare-Pool investiert hat. Wann erhalte ich meine Belohnung?",
        "Wie kann ich mein Level im Empfehlungsprogramm erhöhen?",
      ],
      answers: [
        "Ihre Belohnungen werden direkt auf die mit Ihrem Zenex Hub-Konto verbundene Wallet gutgeschrieben, und Sie können sie auf jedes externe Krypto-Wallet auszahlen.",
        "Es gibt einen einzigen Empfehlungslink für alle Zenex-Produkte. Mit einem Link erhalten Sie Belohnungen für jedes Produkt, das Ihr Referral nutzt.",
        "Belohnungen werden ab dem nächsten Monat gutgeschrieben. Sie erhalten einen Teil der Einzahlung (einmalige Belohnung) sowie einen Teil des Gewinns (monatlich wiederkehrende Belohnungen).",
        "Ihr Level steigt, sobald das gesamte Investitionsvolumen Ihrer Empfehlungen den erforderlichen Schwellenwert erreicht. Das neue Level gilt ab Beginn des nächsten Kalendermonats.",
      ],
    },
    levels: {
      title: "Level- und Belohnungssystem",
      description: "Das Level wird durch den besten Wert bestimmt: Anzahl aktiver Empfehlungen oder Gesamtinvestitionssumme",
      status: {
        received: "Erhalten",
        current: "Aktuelles Level",
        blocked: "Blockiert",
        more: "Noch {count, plural, one {# Empfehlung} other {# Empfehlungen}}",
      },
      level: {
        associate: "Associate",
        partner: "Partner",
        executive: "Executive",
        elite: "Elite",
        ambassador: "Ambassador",
      },
      rows: {
        referrals: "Empfehlungen",
        total: "Gesamteinzahlungen",
        incomeDeposit: "Einkommen aus Einzahlungen",
        incomeStable: "Einkommen aus Stable Pool",
        incomeGrowth: "Einkommen aus Growth Pool",
      },
    },
    filters: {
      label: "Sortieren nach",
      dateAscending: "Datum: aufsteigend",
      dateDescending: "Datum: absteigend",
      incomeAscending: "Einkommen: aufsteigend",
      incomeDescending: "Einkommen: absteigend",
    },
    pagination: "Seite {current} von {total}",
    incomeHistory: {
      title: "Einkommen und Auszahlungsverlauf",
      column: {
        date: "Datum",
        user: "Empfehlung",
        pool: "Pool",
        incomePercent: "Gewinn",
        income: "Betrag",
      },
    },
    referrals: {
      title: "Meine Empfehlungen",
      column: {
        user: "Empfehlung",
        pool: "Pool",
        deposit: "Investiert",
        profit: "Gewinn der Empfehlung",
        earning: "Mein Einkommen",
      },
    },
  },
  quest: {
    title: "Aufgaben und Erfolge",
    subtitle: "Erledigen Sie Aufgaben, um Boni und Belohnungen zu erhalten!",
    subscribe: "Abonnieren Sie uns auf Instagram!",
    follow: "Folgen Sie uns auf X!",
    join: "Treten Sie unserem Telegram bei!",
    done: "Erledigt",
    complete: "Abschließen"
  },
  account: {
    title: "Konto",
    fields: {
      name: "Name",
      nickname: "Spitzname",
      email: "E-Mail",
      bio: "Über mich"
    },
    verify: "Verifizieren",
    confirmChanges: "Änderungen bestätigen",
    updateSuccess: "Änderungen erfolgreich gespeichert",
    updateError: "Änderungen konnten nicht gespeichert werden",
    linksTitle: "Konten verknüpfen für zusätzliche Funktionen",
    connectX: "X verbinden",
    connectTelegram: "Telegram verbinden",
    connectInstagram: "Instagram verbinden",
    logout: "Abmelden",
    emailDialog: {
      title: "E-Mail bestätigen",
      description1: "Wir haben einen 6-stelligen Code an {email} gesendet",
      description2: "Geben Sie ihn unten ein, um die Registrierung abzuschließen und alle Funktionen von Zenex Hub zu nutzen.",
      confirmBtn: "E-Mail bestätigen",
      cantFind: "E-Mail nicht gefunden? Prüfen Sie den Spam-Ordner",
      resend: "oder fordern Sie eine neue an",
      sentPrefix: "Wir haben einen 6-stelligen Code gesendet an"
    },
    cancel: "Abbrechen",
    saveChanges: "Änderungen speichern",
    selectNewAvatar: "Neuen Avatar auswählen",
    unsavedChanges: {
      title: "Ungespeicherte Änderungen",
      subtitle: "Sie haben ungespeicherte Änderungen. Verwerfen und beenden?"
    }
  },
  sell: {
    to: "Auszahlen an",
    select: "Token auswählen",
    button: "Auszahlen",
    loading: "Auszahlung…"
  },
  errors: {
    insufficientFunds: "Unzureichende Mittel",
    maxLimit: "Das maximale Limit ist {value}$",
    serviceUnavailable: "Service nicht verfügbar, bitte versuchen Sie es später erneut",
  },
  card: {
    title: {
      white: "— Die nächste Ära der Kartenzahlungen beginnt hier!",
      green: "von Zenex",
      yellow: "NS.Cards"
    },
    description:
      "Null Transaktionsgebühren, MCC-Beschränkungen, Ausgabelimits bis zu 100.000 $ — all das und mehr mit der Zenex-Karte.",
    button: "Karte bestellen",
    columns: {
      left: {
        title: {
          white: "NS.CARDS für\n",
          green: "Media Buyer"
        },
        items: [
          "Aufladen mit Krypto oder Fiat ab 2,5%",
          "Kein KYC",
          "0% Transaktionsgebühren auf werbebezogene MCCs"
        ],
        cta: "Karte erhalten"
      },
      right: {
        title: {
          white: "NS.CARDS",
          yellow: "No-Limits Wild Card"
        },
        items: [
          "Aufladen mit Krypto oder Fiat ab 2,5%",
          "Keine MCC-Grenzen",
          "Apple Pay/Google Pay + Plastikkarte",
          "100.000 $/Monat für Ihre Transaktionen"
        ],
        cta: "Karte erhalten"
      }
    }
  },
  investHome: {
    title: "RevShare-Pools",
    description:
      "Das erste iGaming-RWA — Finanziere Casinotraffic und verdiene einen % des GGR der Plattform, indem du ZNX RevShare-Pools beitrittst — konservativ oder mit hohem Ertrag.",
    button: "Zenex Invest"
  },
  invest: {
    title: "Traffic-Pools",
    description:
      "Teilnahme an NGR aus dem Traffic des White Rabbit Casino (Kasachstan) - whiterabbit.casino\n" +
      "Wir kaufen hochwertigen Traffic, konvertieren ihn in Einzahlungen und teilen den Gewinn.",
    button: "Updates verfolgen",
    dashboardTitle: "Investitions-Dashboard",
    secondPageDescription1: "Verdiene am GGR von Casinoplattformen.",
    secondPageDescription2: "Wir kaufen hochwertigen Traffic, wandeln ihn in Einzahlungen um und teilen den Gewinn.",
    dashboardDescription: "Verwalte deine Investitionen und verfolge die Performance aller Pools.",
    investFirstRowElements: [
      "Jahre Erfahrung", "Reg2Dep", "monatliche Rendite", "von GGR = NGR"
    ],
    poolsTitle: "Verfügbare Pools",
    pools: ["Mitglieder", "Pool-Typen", "Monate", "ZNX\nGesamtlimit"],
    poolsOffers: {
      titlesStable: ["100% Kapitalrückgarantie", "34–42,5% vom GGR", "Auszahlungen in USDC"],
      titlesGrowth: ["Maximales Aufwärtspotenzial von ZNX", "8,5–12,75% vom GGR", "Auszahlungen in USDC"],
      whyHint: {
        safeTitle: "Warum ein höherer Prozentsatz vom GGR?",
        safeText: "Wir kaufen Ihre ZNX zum aktuellen USD‑Wert an. Der Prozentsatz ist höher, weil wir Ihre Tokens kaufen und maximale Gewinne teilen.\nDie garantierte Rückzahlung Ihrer Investition in USD‑Äquivalent hält Ihr Geld\nsicher.",
        growthTitle: "Warum ein niedrigerer Prozentsatz vom GGR?",
        growthText: "Über 12 Monate verwalten wir Ihre ZNX‑Tokens und stellen sicher, dass Sie am Ende der Laufzeit Ihre gesamte Investition zurückerhalten.\nDer Prozentsatz ist niedriger, weil Sie das Eigentum und das Wachstumspotenzial des Tokens behalten"
      },
      amountStaked: "Eingesetzter Betrag"
    },
    poolsOffersRow: {
      payoutsStable: ["34% vom GGR", "38,25% vom GGR", "42,5% vom GGR"],
      payoutsGrowth: ["8,5% vom GGR", "10,625% vom GGR", "12,75% vom GGR"]
    },
    poolButton: "Pool beitreten",
    nrgComeFrom: {
      title: "Woher kommt das NGR für Auszahlungen?",
      nrgElements: {
        titles: ["GGR von Spielern", "Minus 15%", "= NGR", "An Pool-Teilnehmer"],
        subTitles: ["Brutto-Spielertrag", "Administrative\nKosten des Casinos", "Netto-Spielertrag", "Je nach Stufe\nund Pool-Typ"]
      },
      description: "Beispiel: GGR 100.000 $ → NGR 85.000 $ → Teilnehmer erhalten zwischen 8.500 $ und 42.500 $, abhängig von Pool und Stufe."
    },
    howItWorks: {
      title: "Wie funktioniert es?",
      elements: {
        titles: ["Pooling von ZNX-Token", "Traffic-Akquise", "Gewinn-Generierung", "Monatliche Auszahlungen", "Rückgabe der Anfangsinvestition"],
        descriptions: [
          "Pool-Teilnehmer zahlen ZNX-Token ein\n bis zu einem Limit von 230k Token/Monat",
          "Wir kaufen hochwertigen Traffic im CPA-Modell\n für White Rabbit Casino",
          "Das Casino erwirtschaftet GGR\n= ‘Verluste’ der Spieler – ‘Gewinne’ der Spieler",
          "Pool-Teilnehmer erhalten jeden Monat einen % des GGR\n in USDC basierend auf Stufe und Pooltyp",
          "Die von Ihnen im Pool platzierten Token\n werden nach 12 Monaten vollständig zurückgegeben"
        ]
      }
    },
    faq: {
      title: "Häufig gestellte Fragen",
      questions: [
        "Was sind Zenex RevShare Pools?",
        "Wie erfolgen die Auszahlungen?",
        "Wie wird meine monatliche Auszahlung berechnet?",
        "Kann ich einen Pool vorzeitig verlassen?",
        "Was passiert, wenn der Pool den Zielbetrag nicht erreicht?",
        "Wann erhalte ich meine ZNX zurück?",
      ],
      answers: [
        "Zenex RevShare Pools sind eine RWA-Tokenisierung eines realen Casino-Geschäfts. Du erwirbst ZNX-Token, platzierst sie in Traffic-Akquisitions-Pools für <span>whiterabbit.casino</span> und erhältst jeden Monat über 12 Monate hinweg einen festen Prozentsatz des Gross Gaming Revenue (GGR).",
        "Auszahlungen erfolgen monatlich in USDC am 15. jedes Monats über einen Zeitraum von 12 Monaten. Die Gelder werden deinem ZNX Hub-Guthaben gutgeschrieben und können sofort ausgezahlt oder reinvestiert werden.",
        "Deine Auszahlung hängt von zwei Faktoren ab: deinem Anteil am Pool und der monatlichen GGR-Leistung des Casinos.",
        "Nein, ein vorzeitiger Ausstieg ist nicht möglich. Die Mittel sind für 12 Monate in einem Smart Contract gesperrt. Dies ermöglicht die Planung von Marketingkampagnen und garantiert stabile Erträge.",
        "Der Pool wird in jedem Fall gestartet. Die Gewinnverteilungsanteile werden nach den monatlichen Traffic-Käufen festgelegt.",
        "100 % der ZNX-Token, die du in den Pool eingebracht hast, werden nach 12 Monaten automatisch zurückerstattet.",
      ]
    },
    betshops: {
      title: "Wettshops"
    },
    questions: {
      title: "Noch Fragen?",
      subtitle: "Kontaktieren Sie jetzt unser Team, um den besten Pool für Ihre Ziele zu finden!",
      button: "Kontakt aufnehmen"
    },
    moreInfo: {
      title: "Weitere Informationen über Zenex RevShare Pools",
      telegram: "Unser Telegram",
      instagram: "Unser Instagram",
      linkedin: "Unser LinkedIn"
    },
    payoutVariations: {
      title: "Wie sich Auszahlungen verändern können",
      inputLabel: "Geben Sie den Investitionsbetrag ein",
      weakLabel: "Schwaches Szenario",
      strongLabel: "Starkes Szenario",
      months: [
        "Heute",
        "Jan 2025",
        "Apr 2025",
        "Jul 2025",
        "Okt 2025",
        "Jan 2026",
        "Apr 2026",
        "Jul 2026",
        "Okt 2026",
        "Dez 2026"
      ],
      weakScenarioLabel: "Gesamtrendite im schwachen Szenario (kein Preisanstieg)",
      strongScenarioLabel: "Gesamtrendite im starken Szenario (150% Preisanstieg)",
      disclaimer: "Berechnungen basieren auf historischen Ergebnissen und sind keine Prognosen."
    },
    header: {
      smallTitle: "Zenex RevShare Pools",
      mainHeading: "Profitiere von Casino-Umsätzen ohne operative Kosten und Risiken",
      description: "Wir kaufen hochwertigen Traffic für Casinos, wandeln ihn in Einzahlungen um und teilen die Gewinne",
      ctaStartEarning: "Jetzt verdienen",
      ctaViewStatistics: "Statistiken ansehen",
      stats: {
        item1: {
          value: "60 Monate",
          description: {
            prefix: "Nachgewiesene Profitabilität von",
            link: "White Rabbit Casino"
          }
        },
        item2: {
          value: "40%+",
          description: "Branchenführende Reg‑zu‑Dep‑Conversion"
        },
        item3: {
          value: "Transparent",
          description: "Performance-Reporting und monatliche Daten"
        },
        item4: {
          value: "Zwei Einnahmequellen",
          description: "Monatliche USDC‑Auszahlungen plus vollständige ZNX‑Rückzahlung mit Aufwärtspotenzial"
        }
      }
    },
    enterToPoolDialog: {
      title: "ZNX Gesamtbetrag",
      availableBalance: "Verfügbares Guthaben",
      stakedInPool: "In diesem Pool gestakt",
      buttonTopUp: "Guthaben aufladen",
      buttonEnterPool: "Pool beitreten",
      choosePlan: "Wählen Sie Ihren Plan",
      inputLabel: "ZNX-Betrag eingeben",
      inputMessages: {
        exceedsBalance: "Übersteigt Guthaben",
        increase: {
          toIncrease: "Um Ihren",
          addAdditional: "zu erhöhen, fügen Sie hinzu",
          stable: {
            toBasic: "GGR auf 34%",
            toAdvanced: "GGR auf 38,25%",
            toPremium: "GGR auf 42,5%"
          },
          growth: {
            toBasic: "GGR auf 8,5%",
            toAdvanced: "GGR auf 10,625%",
            toPremium: "GGR auf 12,75%"
          }
        }
      }
    },
    myActivePools: {
      title: "Meine aktiven Pools",
      myActivePoolElements: ["Eingesetzt", "Aktueller\nPlan", "GGR"],
      myActivePoolElementsV2: ["Poolgröße", "Eingesetzt", "Aktueller Plan", "GGR", "Gesamt verdient"],
      growUp: "Plan upgraden, um die Erträge zu steigern!",
      missing: "Fehlen",
      buttonStats: "Statistiken anzeigen",
      buttonAddZNX: "ZNX hinzufügen",
      buttonClaim: "Einlösen",
      months: {
        january: "Januar",
        february: "Februar",
        march: "März",
        april: "April",
        may: "Mai",
        june: "Juni",
        july: "Juli",
        august: "August",
        september: "September",
        october: "Oktober",
        november: "November",
        december: "Dezember"
      },
      status: {
        active: "Aktiv bis {date}",
        prefunding: "Vorfinanzierung",
        closed: "Geschlossen",
      },
      upgrade: {
        label: "Upgrade deinen Plan auf",
        boost: "Steigere die Einnahmen auf {percent}% aus GGR ({ggr})",
        missing: "Fehlt: ",
      },
    },
    stats: {
      title: "White Rabbit Analyse-Dashboard",
      description: "Operative Analytik",
      claimButton: "Claimen",
      chartPerios: ["1T", "1W", "1M"],
      chartLine: "Dynamik des GGR",
      barLine: "Dynamik Aktive Spieler",
      addZnx: "ZNX hinzufügen",
      spent: "Ausgegeben",
      ftdLabel: "FTD\n(Erstzahler)",
      cpaLabel: "CPA\n(Kosten pro FTD)",
      averageDeposit: "Durchschnittliche Einzahlung",
      ggrThisMonth: "GGR in diesem Monat",
      totalGgr: "Gesamt-GGR",
      day: "Tag {day}",
      activity: {
        title: "Pool-Aktivitätsstatus",
        status: {
          active: "Aktiv bis {date}",
          prefunding: "Vorfinanzierung",
          closed: "Geschlossen",
          traffic: "Traffic-Akquise"
        },
      },
      prefunding: {
        goal: "Finanzierungsziel",
        raised: "Eingesammelt",
        investors: "Investoren",
        launch: "Start in"
      },
      stake: {
        label: "Mein Einsatz",
        elements: ["Gestakt", "Aktueller Plan", "GGR", "Nächste Auszahlung", "Gesamt verdient"],
      },
      upgrade: {
        label: "Upgrade deinen Plan auf",
        boost: "Erhöhe die Einnahmen auf {percent}% aus GGR ({ggr})",
        missing: "Fehlt: ",
      },
      placeholderPool: {
        title: "Statistiken sind nach dem Pool-Start verfügbar",
        description: "Jetzt investieren, um frühzeitig Zugriff auf Leistungsdaten zu erhalten!",
        action: "Pool beitreten",
      },
      myPayouts: {
        title: "Meine Auszahlungen",
        action: "Einlösen",
        pool: "{pool}-Auszahlung für {month}",
        stable: "Stable Pool",
        growth: "Growth Pool",
        eta: {
          days: "{count, plural, one {# Tag} other {# Tage}}",
          hours: "{count, plural, one {# Stunde} other {# Stunden}}",
        },
      },
      months: {
        january: "Januar",
        february: "Februar",
        march: "März",
        april: "April",
        may: "Mai",
        june: "Juni",
        july: "Juli",
        august: "August",
        september: "September",
        october: "Oktober",
        november: "November",
        december: "Dezember"
      },
      yourPayouts: "Ihre"
    },
    transparency: {
      title: "Transparenz",
      lastUpdated: "Zuletzt aktualisiert:",
      dataSource: "Datenquelle:",
      crossGamingRevenue: "Brutto-Spielertrag (GGR)",
      adminFee: "Admin-Gebühr (15%)",
      netGamingRevenue: "Netto-Spielertrag (NGR)",
      totalDeposits: "Gesamteinzahlungen",
      playersCount: "Anzahl Spieler"
    },
    overview: {
      title: "Überblick persönliche Investitionen",
      totalInvested: "Insgesamt investiert",
      totalEarned: "Insgesamt verdient",
      nextPayout: "Nächste Auszahlung",
      poolShare: "Ihr Pool-Anteil:",
      roi: "ROI:",
      paymentDate: "Zahlungsdatum:",
      poolMetrics: "Pool-Metriken",
      poolSize: "Pool-Größe",
      investors: "Investoren",
      staked: "Eingesetzt",
      players: "Spieler"
    },
    totalStaked: {
      title: "Insgesamt im Pool eingesetzt",
      button: "In Pools investieren",
      stable: "stable pool",
      growth: "growth pool",
      totalFormat: "{total}/{max} ZNX"
    },
    whiteRabbitPromo: {
      title: "White Rabbit Pool-Statistiken",
      subtitle: "Zahlen ansehen, Erträge berechnen, jetzt beitreten",
      button: "Statistiken öffnen"
    },
    poolMetrics: {
      title: "Pool-Metriken",
      metricsElements: ["Pool-Größe", "Investoren", "Eingesetzt", "Spieler"]
    },
    growthDetails: {
      title: "Zenex Growth Pool",
      progress: {
        label: "Pool‑Fortschritt"
      },
      metrics: {
        ggrShareLabel: "Anteil am Casino‑GGR",
        lockPeriodLabel: "Sperrfrist",
        lockPeriodValue: "12 Monate",
        payoutsUSDCLabel: "Auszahlungen in USDC",
        payoutsFrequencyValueMonthly: "Monatlich",
        returnedAfterLabel: "Rückgabe nach 12 Monaten",
        returnedAfterValue: "100% ZNX"
      },
      tooltips: {
        tierShare: "Ihr Anteil am Casino hängt von der Stufe ab",
        payoutsDepend: "Auszahlungen hängen vom monatlichen GGR des Casinos ab",
        noEarlyWithdrawal: "Keine vorzeitige Auszahlung",
        znxGrowth: "Wenn ZNX steigt, steigt auch Ihre Endrendite"
      },
      tier: {
        depositLabel: "Einzahlung:",
        note: "Stufe wird automatisch anhand der Einzahlungssumme bestimmt"
      },
      button: {
        closed: "Fundraising geschlossen"
      }
    },
    joinPool: "Pool beitreten",
    poolsPromoTitle: "Statistiken erscheinen nach dem Pool-Start",
    poolsPromoSubtitle: "Investieren Sie jetzt für frühen Zugang zu Leistungsdaten!"
  },
  buy: {
    currency: "Währung",
    network: "Netzwerk",
    sum: "Betrag",
    min: "Minimum",
    max: "Maximum",
    loading: "Laden…",
    buy: "Kaufen",
    approve: "Überweise {amount} {currency} an Adresse:"
  },
  claim: {
    have: "Sie haben",
    available: "Token verfügbar",
    description:
      "Klicken Sie auf die Schaltfläche \"Claim\", um sie Ihrem Kontostand hinzuzufügen.",
    button: "Claim",
    check: "Prüfen",
    total: "Ihre Gesamtpunktzahl",
    tooltip: "Optionales Feld",
    notice: {
      white: "Geben Sie den Bonuscode ein, um",
      green: "x2 ZNX-Token zu erhalten."
    },
    errors: {
      invalidCode: "Ungültiger Code",
      codeExpired: "Der Code ist abgelaufen.",
      codeRequired: "Der Code ist erforderlich."
    },
    optional: "Optionales Feld"
  },
  page: {
    title: {
      green: "Willkommen bei",
      yellow: "Zenex Hub!"
    },
    descriptions1:
      "Danke, dass Sie an uns glauben und mit uns wachsen wollen!",
    descriptions2:
      "Wir befinden uns in der finalen Testphase und werden bald unsere volle Funktionalität vorstellen.",
    descriptions3: "Spielen Sie jetzt, um Ihre",
    descriptions4: "kostenlosen Token",
    descriptions5: "zu erhalten — verpassen Sie es nicht!",
    buttons: {
      play: "Treasure Hunt spielen",
      get: "ZNX erhalten"
    },
    notice: "Dieses Angebot ist nur für kurze Zeit verfügbar.",
    back: "Zurück",
    tabs: {
      account: "Konto",
      safety: "Sicherheit",
      notifications: "Benachrichtigungen",
      referrals: "Empfehlungen",
      quests: "Quests"
    }
  },
  balance: {
    title: "Ihre NFT-Kollektionen"
  },
  header: {
    title: {
      profile: "Profileinstellungen",
      reshare:"Investition"
    },
    welcome: "Willkommen {username}!",
    welcome_empty: "Willkommen!",
    button: {
      logout: "Abmelden"
    },
    labels: {
      address: "Adresse:",
      caipAddress: "CAIP-Adresse:",
      status: "Status:"
    },
    dropdown: {
      supportChat: "Support-Chat",
      documents: "Dokumente",
      legalDocuments: "Rechtliche Dokumente",
      termsOfUse: "Nutzungsbedingungen",
      privacyPolicy: "Datenschutzrichtlinie",
      cookiesPolicy: "Cookie-Richtlinie",
      buyZNXwithCrypto: "ZNX mit Krypto kaufen",
      buyZNXonDEX: "ZNX auf DEX kaufen",
      buyZNXwithCard: "ZNX mit Karte kaufen"
    }
  },
  login: {
    title: {
      green: "Willkommen bei",
      white: "Zenex Hub!"
    },
    button: "Verbinden"
  },
  plans: {
    title: "Zenex Investment-Zugangsprogramme",
    welcome: "Willkommen {username}!",
    welcome_empty: "Willkommen!",
    cards: {
      silver: {
        title: "Silber-Stufe",
        subtitle: "Früher Investor",
        items: [
          "1.000 Plätze",
          "ZNX Play: Staking ×1,5 (6 Mon.)",
          "ZNX Arena: 5 Standardkarten + 1 Gold",
          "ZNX Invest: Exklusiver Pool-Zugang",
          "Bonus: 850 ZNX"
        ]
      },
      gold: {
        title: "Gold-Stufe",
        subtitle: "Strategischer Partner",
        items: [
          "200 Plätze",
          "ZNX Play: Staking ×2 (12 Mon.)",
          "ZNX Arena: 8 Standardkarten + 2 Gold",
          "ZNX Invest: +10% Pool-Rendite",
          "Bonus: 4.200 ZNX"
        ]
      },
      platinum: {
        title: "Platin-Stufe",
        subtitle: "VIP-Investor",
        items: [
          "50 Plätze",
          "ZNX Play: Staking ×3 (12 Mon.)",
          "ZNX Arena: 10 Standardkarten + 3 Gold",
          "ZNX Invest: +20% Pool-Rendite",
          "Privater Insider-Chat",
          "Bonus: 12.500 ZNX"
        ]
      },
      diamond: {
        title: "Diamant-Stufe",
        subtitle: "Gründungspartner",
        items: [
          "20 Plätze",
          "ZNX Play: Staking ×4 (12 Mon.)",
          "ZNX Arena: 10 Standardkarten + 5 Gold",
          "ZNX Invest: +30% Rendite + garantierte Zuteilungen",
          "Privater Chat + Einfluss auf die Plattform",
          "Nennung in der Hall of Fame",
          "Bonus: 12.500 ZNX"
        ]
      }
    },
    button: "Kaufen",
    available: "Verfügbare Positionen",
    benefits: "Vorteile"
  },
  opportunities: {
    cards: {
      play: {
        title: "ZNX Play",
        description: "ZNX halten, verdienen — ohne Aufwand."
      },
      invest: {
        title: "ZNX Invest",
        description:
          "Verdiene mit dem ersten iGaming-RWA schon ab 50 ZNX"
      },
      cases: {
        title: "Cases & Truhen",
        description: "Öffne Cases für zufällige Belohnungen, Booster oder Vorteile."
      },
      arena: {
        title: "ZNX Arena",
        description:
          "Profitiere von Promotern, die um Kunden in einer Business-Reality-Show konkurrieren."
      }
    },
    button: "Bald verfügbar",
    buttonOpen: "Öffnen"
  },
  meta: {
    title: "Deutsch"
  },
  cards: {
    transactions: {
      title: 'Letzte Transaktionen',
      column: {
        card: "Karte",
        date: "Datum",
        details: "Details",
        status: "Status",
        amount: "Betrag",
        fee: "Gebühr"
      },
      status: {
        RESERVED: "Reserviert",
        UNRESERVED: "Freigegeben",
        TRANSFERRED: "Übertragen",
        REFUNDED: "Erstattet",
        REFUNDED_PARTIAL: "Teilerstattung",
        FAILED: "Fehlgeschlagen",
        LOADED: "Aufgeladen",
        UNLOADED: "Entladen",
        COMPLETED: "Abgeschlossen"
      }
    },
    myCards: {
      title: "Meine Karten",
      goToSite: "Zu NS.Cards wechseln",
      balance: 'Guthaben',
      buyNewCards: "Neue Karte kaufen",
      cardRedirect: "Sie werden zu einem externen Dienst weitergeleitet, um Ihren Kauf abzuschließen",
      topUpZnx: "Mit ZNX aufladen",
      confirmTopUp: "Aufladung bestätigen",
      topUpAmount: 'Aufladebetrag',
      viewAllCards: 'Alle Karten anzeigen',
      hideCards: 'Karten ausblenden',
      loading: 'Wird geladen',
      loadingAddress: 'Einzahlungsadresse wird geladen...',
    }
  },
  wallet: {
    title: {
      main: "Wallet",
      mainNew: "Non-Custodial-Wallet",
      cards: "Zenex Cards",
      balance: "Gesamtvermögen",
      transaction: "Transaktionshistorie",
      calendar: "Zahlungskalender",
      payments: "Bevorstehende Zahlungen"
    },
    availableBalance: "Verfügbares Guthaben",
    chooseAssets: "Asset auswählen",
    walletNetworkDeposit: "Einzahlungsnetzwerk",
    walletNetworkWithdraw: "Auszahlungsnetzwerk",
    address: "Adresse",
    destinationAddress: "Zieladresse",
    enterAddress: "Adresse eingeben",
    pasteWalletAddress: "Wallet-Adresse einfügen",
    enterAmount: "Betrag eingeben",
    withdrawAmount: "Auszahlungsbetrag",
    minimumWithdrawAmount: "Mindestbetrag für die Auszahlung: {value}",
    transactionDetails: "Transaktionsdetails",
    transactionFee: "Transaktionsgebühr",
    insufficientFundsForFee: "Nicht genug Mittel, um die Transaktionsgebühr zu decken.",
    missing: "Fehlt: {value}",
    addSol: "SOL hinzufügen",
    paste: "Einfügen",
    max: "Max",
    doubleCheckWithdraw: "Bitte prüfen Sie die Auszahlungsadresse sorgfältig!",
    doubleCheckDeposit: "Bitte prüfen Sie die Einzahlungsadresse sorgfältig!",
    sendingFundsToWrong: "Das Senden von Geldern an eine falsche Adresse kann zum unwiederbringlichen Verlust\n Ihrer Kryptowährung führen.",
    theProcedureUpTo48Hours: "Der Vorgang kann 1-2 Minuten dauern!",
    theProcedureUpTo30min: "Das Verfahren kann bis zu 30 Minuten dauern",
    exRate: "Wechselkurs",
    swap: "Bestätigen",
    sell: "Verkaufen",
    receive: "Empfangen",
    send: "Senden",
    mainTitle: "Tausch",
    amount: "Betrag",
    toSwap: "Tauschen",
    searchTokens: "Token suchen",
    selectCurrency: "Währung auswählen",
    selectCurrencyOrNetwork: "Währung oder Netzwerk auswählen",
    selectToken: "Token auswählen",
    selectNetwork: "Netzwerk auswählen",
    continueInWallet: "Im Wallet fortfahren",
    swapReview: "Bitte prüfen Sie die Transaktionsdetails\n vor der Bestätigung!",
    depositAddress: "Einzahlungsadresse",
    walletDepositLoading: "Bitte warten, Ihre Einzahlungsadresse wird generiert...",
    walletSwapDepositLoading: "Bitte warten, Ihre Swap-Operation wird initialisiert...",
    swapPage: {
      youSend: "Sie senden",
      youReceive: "Sie erhalten",
      swapMinDeposit: "Min. Einzahlung",
      fee: "Gebühr",
      feeWithdraw: "Auszahlungsgebühr",
      finish: "Fertig",
      swapSuccess: "Tausch erfolgreich abgeschlossen",
      swapError: "Tausch fehlgeschlagen. Bitte versuchen Sie es erneut."
    },
    balanceButtons: {
      deposit: "Einzahlen",
      withdraw: "Abheben",
      exchange: "Tauschen",
      buyZNX: "ZNX kaufen"
    },
    transactionHistory: {
      type: "Typ",
      total: "Gesamt",
      info: "Info",
      date: "Datum",
      status: "Status"
    }
  },
  paymentProcess: {
    awaitingPayment: "Warte auf Zahlung",
    confirmed: "Bestätigt",
    swapped: "Getauscht",
    swapping: "Wird getauscht",
    sending: "ZNX wird gesendet",
    sendingToken: "{token} wird gesendet",
    usualTime: "Dies dauert normalerweise 5–30 Minuten."
  },
  transactionStatus: {
    complete: "Transaktion abgeschlossen!",
    failed: "Transaktion fehlgeschlagen",
    withdrawFailed: "Auszahlung fehlgeschlagen",
    successSend: "{token} wurde erfolgreich an Ihr Wallet gesendet.",
    errorOccurred: "Bei der Verarbeitung der Transaktion ist ein Fehler aufgetreten.",
    viewOnExplorer: "Im Block-Explorer ansehen",
    contactSupport: "Support kontaktieren",
    backToWallet: "Zurück zur Wallet",
    withdrawComplete: "Auszahlung abgeschlossen!",
    withdrawAmountLabel: "Auszahlungsbetrag",
    destinationAddressLabel: "Empfängeradresse",
    estimatedProcessingTimeLabel: "Geschätzte Bearbeitungszeit",
    transactionFeeLabel: "Transaktionsgebühr",
    continueInWallet: "In Wallet fortfahren",
    checkOnSolscan: "In Solscan prüfen",
    withdrawEtaValue: "{value} Minuten",
    withdrawEtaDefault: "1-2 Minuten",
    swapComplete: "Tausch abgeschlossen!",
    swapFailed: "Tausch fehlgeschlagen",
    youSendLabel: "Sie senden",
    exchangeRateLabel: "Wechselkurs",
    youGetLabel: "Sie erhalten"
  },
  play: {
    banner: {
      title: "Staking & Lotterie",
      description: "Stake deine $ZNX-Token, um Belohnungen zu verdienen. Je länger du stakest, desto höher deine Gewinnchancen!"
    },
    statsSmall: {
      previousJackpot: "Vorheriger Jackpot",
      upcomingPayment: "Bevorstehende Zahlung",
      activeParticipants: "Aktive Teilnehmer"
    },
    ctaStake: "Staken und gewinnen",
    chipActive: "Aktiv",
    stats: {
      totalValueStaked: "Gesamt gestaketer Wert",
      activeStakers: "Aktive Staker",
      currentPrizePool: "Aktueller Preispool"
    },
    nextDraws: {
      title: "Nächste Ziehungen",
      description: "Countdown bis zur nächsten Preislotterie. Verpassen Sie Ihre Chance nicht!"
    },
    jackpots: {
      weekly: "WÖCHENTLICHER JACKPOT",
      monthly: "MONATLICHER JACKPOT",
      annual: "JÄHRLICHER JACKPOT"
    },
    time: {
      days: "Tage",
      hours: "Stunden",
      minutes: "Minuten"
    },
    prizeSub: "im Preispool",
    stakeDialog: {
      header: "Staking starten",
      description: "Wählen Sie Betrag und Dauer für maximales Gewinnpotenzial",
      labelAmount: "Zu stakender Betrag (ZNX)",
      placeholderAmount: "Betrag eingeben",
      max: "MAX",
      infoMessage: "Erhöhen Sie den Stake auf 500 ZNX, um Ihren potenziellen Gewinn zu verdoppeln!",
      plan: {
        multiplier: "Multiplikator",
        labelApy: "Feste APY"
      },
      stats: {
        weeklyDistribution: "Wöchentliche Ausschüttung",
        monthlyDistribution: "Monatliche Ausschüttung",
        totalPotentialProfit: "Gesamtes Potenzial"
      },
      createStake: "Stake erstellen"
    },
    summaryRow: {
      stakeAmount: "Stake-Betrag",
      duration: "Dauer",
      fixedApy: "Feste APY",
      guaranteedProfit: "Garantierter Gewinn",
      additionalProfitChance: "Zusätzliche Gewinnchance"
    }
  },
  connectDialog: {
    text: "Verbinden Sie Ihr Wallet, um alle verfügbaren Produkte zu sehen!",
    button: "Wallet verbinden"
  },
  profileCard: {
    hiUser: "Hallo, Benutzer",
    copyFullAddress: "Vollständige Adresse kopieren",
    profileSettings: "Profileinstellungen"
  },
  welcomeDashboard: {
    subTitle: "Engagiere dich. Verdiene. Ermächtige.",
    description: "Das erste iGaming-Fintech-Ökosystem mit Casino-RWA und revolutionären Lösungen!",
    button: "Wallet verbinden",
    revsharePools: {
      titleAccent: "Revshare",
      titleRest: "Pools",
      description1: "Das erste iGaming‑RWA — Finanzieren Sie CPA‑Casino‑Traffic und verdienen Sie einen % der Plattformumsätze (GGR)",
      description2: "indem Sie den ZNX RevShare‑Pools für konservative oder renditestarke Gewinne beitreten.",
      cta: "Jetzt verdienen"
    },
    dashboardElements: {
      invest: {
        text: "Verdiene jeden Monat mit den branchenführenden\nCasino‑RWA‑Produkten",
        button: "ZNX & USDC verdienen"
      },
      play: {
        text: "Halte ZNX, erziele passives Einkommen,\nund vervielfache es in unseren Minispielen.",
        button: ""
      },
      arena: {
        text: "Profitiere von Promotern, die im ersten Casino‑Business‑Reality‑Format um Kunden konkurrieren.",
        button: ""
      }
    },
    dashboardReferral: {
      boost: "Verdiene mehr mit dem",
      programName: "Empfehlungsprogramm"
    },
    dashboardConnect: {
      subTitle: "Engagieren. Verdienen. Ermächtigen.",
      text: "Das erste iGaming-Fintech-Ökosystem\nmit Casino-RWA und revolutionären Lösungen!"
    },
    dashboardPartners: {
      title1: "Globales Netzwerk.",
      title2: "Geteilte Vision.",
      subTitle: "Integriert mit führenden iGaming- und Fintech-Partnern nutzen wir Blockchain- und Smart-Contract-Technologien, um Lösungen der nächsten Generation zu entwickeln."
    },
    dashboardPhotos: {
      title: "Momente",
      subtitle: "Menschen. Energie. Innovation.",
      followUs: "Folge uns für weitere Momente",
      texts: {
        We_brought: "Wir brachten den Web3-Geist nach MAC Eriwan",
        Innovation_networking: "Innovation, Networking und mutige Ideen – das ist CPA Life Fest mit Zenex",
        Zenex_at: "Zenex bei BroConf – pure Energie",
        Connecting_minds: "Vernetzung von Köpfen bei TOKEN2049",
        Game_on: "Spiel an beim SBC Summit",
        From_insights: "Von Erkenntnissen zu Aktionen – beim CPA Life Fest",
        TOKEN2049_vibes: "TOKEN2049-Vibes: echte Gespräche, Wachstum, Energie",
        Behind_every: "Hinter jedem Event steckt eine Geschichte – von mutigen Ideen, Partnerschaften und unvergesslichen Erlebnissen, die die Zenex-Community voranbringen.",
        Bright_ideas: "Leuchtende Ideen, SiGMA"
      }
    }

  }
};
